module.exports = __webpack_public_path__ + "static/media/neeraj_pr.fbef3e97.jpeg";